import { BicycleSpecKey } from "../../../../commons/specs/bicycle";
import { ActiveFilters } from "../../../../commons/specs/filters";
import { getGearBrandKeyForSeries, getGearSeriesMatrix, type GearBrandKey } from "../../../../commons/specs/gear";
import { ProductType } from "../../../../commons/specs/product";
import { getActiveFilterValues, removeActiveFilterValue } from "../../libs/filters";

interface GearBrandFilterValue {
  value: string;
  label: string;
}

export const sortGearBrandFilterValues = <FilterValue extends GearBrandFilterValue>(
  filterValues: FilterValue[]
): FilterValue[] => {
  return [...filterValues].sort((first, second) => {
    const matrixOrder =
      Number(Boolean(getGearSeriesMatrix(second.value as GearBrandKey))) -
      Number(Boolean(getGearSeriesMatrix(first.value as GearBrandKey)));

    if (matrixOrder !== 0) {
      return matrixOrder;
    }

    return first.label.localeCompare(second.label) || first.value.localeCompare(second.value);
  });
};

export const removeGearBrandActiveFilters = (
  activeFilters: ActiveFilters<ProductType.Bicycle>,
  brandKey: string
): ActiveFilters<ProductType.Bicycle> => {
  const filtersWithoutBrand = removeActiveFilterValue(activeFilters, BicycleSpecKey.GearBrandKey, brandKey);
  const selectedSeriesKeys = getActiveFilterValues(activeFilters, BicycleSpecKey.GearSeriesKey) ?? [];

  return selectedSeriesKeys
    .filter(seriesKey => getGearBrandKeyForSeries(String(seriesKey)) === brandKey)
    .reduce(
      (filters, seriesKey) => removeActiveFilterValue(filters, BicycleSpecKey.GearSeriesKey, seriesKey),
      filtersWithoutBrand
    );
};
